import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Layout Components
import Header from "./components/Header";
import Footer from "./components/Footer";

// Pages
import LandingPage from "./pages/LandingPage";
import AboutDetails from "./pages/AboutDetails";
import ContactSection from "./pages/ContactSection";
import Cart from "./pages/Cart";
import Rental from "./pages/Rental";
import Projects from "./components/Projects"; // 👈 ADD THIS

export default function App() {
  const [cart, setCart] = useState([]);

  const addToCart = (machine) => {
    if (!cart.find((item) => item.id === machine.id)) {
      setCart([...cart, machine]);
    }
  };

  const removeFromCart = (id) => {
    setCart(cart.filter((item) => item.id !== id));
  };

  return (
    <BrowserRouter>
      {/* Global Header */}
      <Header />

      {/* Routes */}
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<AboutDetails />} />
        <Route path="/projects" element={<Projects />} /> {/* 👈 NEW */}
        <Route path="/rental" element={<Rental addToCart={addToCart} />} />
        <Route
          path="/cart"
          element={<Cart cart={cart} removeFromCart={removeFromCart} />}
        />
        <Route path="/contact" element={<ContactSection />} />
      </Routes>

      {/* Global Footer */}
      <Footer />
    </BrowserRouter>
  );
}
